import { ModelSearchResult, PermissionsUtil } from "@mcleod/core";
import { ClickEvent } from "@mcleod/components";
import { ModelCarrierInsCtrl } from "@mcleod/powerbroker";
import { AddCarrier } from "./AddCarrier";
import { OnboardCarrier } from "./OnboardCarrier";
import { AutogenLayoutCarrierList } from "./autogen/AutogenLayoutCarrierList";

export class CarrierList extends AutogenLayoutCarrierList {

    private vendor_id: string;
    private packet_website_url: string;
    private carrierins_control_onboarding_server: string;
    private add_vendors = ['S', 'C', 'P', 'D', 'H', 'R'];
    private auto_onboard_vendors = ['D', 'H', 'R'];

    override async onLoad(): Promise<void> {
        await this.setCarrierListInstanceFields();
        this.btnAddCarrier.visible = false;
        this.btnInviteCarrier.visible = false;
        this.btnAddCarrier.enabled = true;
        this.btnInviteCarrier.enabled = true;

        if (this.add_vendors.includes(this.vendor_id) && !PermissionsUtil.isUserDeniedLayout("lme/dispatch/AddCarrier")) {
            this.btnAddCarrier.visible = true;
        }

        if ( this.auto_onboard_vendors.includes(this.vendor_id) && !PermissionsUtil.isUserDeniedLayout("lme/dispatch/OnboardCarrier")) {
            this.btnInviteCarrier.visible = true;
        }

    }

    btnAddCarrierOnClick(event: ClickEvent) {
        AddCarrier.showSlideout(this.vendor_id, "", "", "", this.carrierins_control_onboarding_server, this.packet_website_url);
    }

    btnInviteCarrierOnClick(event: ClickEvent) {
        OnboardCarrier.showSlideout(null, null, true, "");
    }
    async setCarrierListInstanceFields() {
        await new ModelCarrierInsCtrl().search()
            .then((result: ModelSearchResult) => {
                if (result.modelRows[0] !== undefined) {
                    this.vendor_id = result.modelRows[0].get('vendor_id');
                    this.packet_website_url = result.modelRows[0].get('packet_website_url');
                    this.carrierins_control_onboarding_server = result.modelRows[0].get('onboarding_server');
                }
            });
    }
}


